/**
 * Use requestIdleCallback function to trigger the callback function during an idle time.
 * It will fallback to setTimeout is requestIdleCallback is undefined (Safari browser)
 * @param callback function to execute when idle time is detected
 * @returns a function to cancel the callback
 */
export function requestIdleOrTimeoutCallback(callback: IdleRequestCallback) {
  if ('requestIdleCallback' in window) {
    const id = window.requestIdleCallback(callback)
    return () => window.cancelIdleCallback(id)
  }
  else {
    const id = setTimeout(callback, 0)
    return () => clearTimeout(id)
  }
}
